import { environment } from './../../../environments/environment.prod';
import { Injectable } from '@angular/core';
// import { HttpHeaders, HttpClient } from '@angular/common/http';
// import { Observable, of } from 'rxjs';
// import { map, tap } from 'rxjs/operators';
import { environment as defaultConfig } from '../../../environments/environment';
import { Storage } from './storage.service';
import { StorageCollections } from '../enum/storage-collections.enum';

export interface RuntimeConfig {
  carrierApiUrl: string;
  apiUrl: string;
  userManagementApiUrl: string;
  apiHost: string;
  envName: string;
  authClientId: string;
  authClientSecret: string;
  authBaseUrl: string;
  samlKeepAliveUrl: string;
  sessionCookie: string;
  locationApiUrl: string;
  orderApiUrl: string;
  hubconnectPortalUrl: string;
  hubconnectApiUrl: string;
}

export interface EnvironmentConfig {
  production: boolean;
  subDomain: string;
  apiVersion: string;
  runtime: RuntimeConfig;
  max_session_refresh_period_in_seconds: number;
  showErrors: boolean;
  envName: string;
}

@Injectable()
export class ConfigService {
  private config: Promise<string>;

  constructor(private storage: Storage) {
    this.config = this.getConfigFromStorage();
  }

  public async getConfig(): Promise<EnvironmentConfig> {
    const configFromStorage = await this.config;
    return configFromStorage
      ? JSON.parse(configFromStorage)
      : Promise.resolve(defaultConfig);
  }

  private getConfigFromStorage(): Promise<string> {
    return this.storage.getItem('config', StorageCollections.CONFIG);
  }
}
